"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var main_1 = require("./screens/main");
var store_1 = require("./store");
var App = function () {
    return ((0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: store_1.redux_store, children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.BrowserRouter, { children: [(0, jsx_runtime_1.jsx)(react_1.ToastProvider, { placement: "top" }), (0, jsx_runtime_1.jsx)(main_1.MainScreen, {})] }) }));
};
exports.App = App;
